import { PlayerModel, RatingAttribute, RatingCategory } from "./models/models";
import { Rating } from "./models/ratings";
import { average } from "./utility";

function getCategoryValue(categoryName: RatingCategory, player: PlayerModel) {


    const hasAttributeRatings = player.attributeRatings !== undefined;


    let attributesToCheck = hasAttributeRatings ? player.attributeRatings.filter(attr => attr.category === categoryName).map(attr => attr.name) : (
        player.attributes.filter(attr => attr.category === categoryName).map(attr => (attr.name.toLowerCase() as RatingAttribute))
    );


    const currentAttributes: number[] = [];

    attributesToCheck.forEach(attributeName => {
        currentAttributes.push(getAttributeValue(attributeName, player))
    })

    return average(currentAttributes);
}
function getAttributeValue(attributeName: RatingAttribute, player: PlayerModel) {
    const attributeVals = player.attributes.filter(attr => attr.name.toLowerCase() === attributeName);
    const item = attributeVals[attributeVals.length - 1];

    if (item.rawValue === undefined) {
        // Old style
        const stars = (item.value * 5);
        return stars;
    }
    return item.value

}

function getValueForPlayer(rating: Rating, player: PlayerModel): number {

    if (rating.type === "Category") {
        return getCategoryValue(rating.category, player)
    }
    if (rating.type === "Attribute") {

        return getAttributeValue(rating.attribute, player);
    }

    // Never
    return 0;

}


export const StarMath = {
    getValueForPlayer
}